import {Locales} from '@netx/core-next/locales/utils/Locales';
import {CustomActionField, type ICustomAction} from './schema';

export const CUSTOM_ACTION_COLUMN_LABEL = Locales<
	Partial<Record<keyof ICustomAction, string>>
>((i18n) => ({
	[CustomActionField.contextName]: i18n('i18n.contextName'),
	[CustomActionField.enabled]: i18n('i18n.status'),
	[CustomActionField.id]: i18n('i18n.id'),
	[CustomActionField.name]: i18n('i18n.label'),
	[CustomActionField.payloadUrl]: i18n('i18n.endpointUrl'),
	[CustomActionField.targetUrl]: i18n('i18n.targetUrl'),
	[CustomActionField.userSelector]: i18n('i18n.userSelector'),
}));

export const CUSTOM_ACTION_ACTION_LABEL = Locales((i18n) => ({
	ADD: i18n('i18n.addCustomAction'),
	CREATE: i18n('i18n.create'),
	DONE: i18n('i18n.done'),
	DELETE: i18n('i18n.delete'),
	EDIT: i18n('i18n.edit'),
	REGENERATE_SECRET: i18n('i18n.regenerateSecret'),
	SAVE: i18n('i18n.save'),
}));

export const CUSTOM_ACTION_TITLE = Locales((i18n) => ({
	CREATE_CUSTOM_ACTION: i18n('i18n.create'),
	CONFIRM_REGENERATE: i18n('i18n.regenerateSecretConfirmTitle'),
	CONFIRM_DELETE: i18n('i18n.customActionDeleteConfirmTitle'),
	CUSTOM_ACTION: i18n('i18n.customAction'),
	CUSTOM_ACTIONS: i18n('i18n.customActions'),
	EDIT_CUSTOM_ACTION: i18n('i18n.edit'),
}));

export const CUSTOM_ACTION_LABEL = Locales((i18n) => ({
	ANY: i18n('i18n.any'),
	ACCESS: i18n('i18n.access'),
	CLOSE: i18n('i18n.close'),
	DISABLED: i18n('i18n.disabled'),
	ENABLED: i18n('i18n.enabled'),
	NAME_HELP: i18n('i18n.customActionLabelHelp'),
	PAYLOAD_URL_HELP: i18n('i18n.customActionEndpointUrlHelp'),
	SECRET: i18n('i18n.secret'),
	STATUS: i18n('i18n.status'),
	TARGET_URL_HELP: i18n('i18n.customActionTargetUrlHelp'),
	TEST_ENDPOINT_URL: i18n('i18n.test'),
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const CUSTOM_ACTION_MESSAGE = Locales((i18n) => ({
	CHECKING_ENDPOINT: i18n('i18n.checkingEndpointMessage'),
	CONFIRM_DELETE: i18n('i18n.actionPermanent'),
	CONFIRM_REGENERATE: i18n('i18n.regenerateSecretConfirmMessage'),
	ENDPOINT_ACCESSIBLE: i18n('i18n.endpointAccessibleMessage'),
	ENDPOINT_INACCESSIBLE: i18n('i18n.endpointInaccessibleMessage'),
	FAILED: i18n('i18n.customActionFailed'),
	NO_MATCHING_RECORDS: i18n('i18n.noRecords'),
	NO_RECORDS: i18n('i18n.noCustomActions'),
	PERFORMING_ACTION: i18n('i18n.waitProcessing'), // i18n('i18n.customActionPerformingActionMessage'),
	SECRETE_MESSAGE: i18n('i18n.generatedSecretMessage'),
	SUCCEEDED: i18n('i18n.customActionSucceeded'),
	ERROR: i18n('i18n.error'),
}));
